//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from 'swiper';
import {throttle} from "throttle-debounce";

function minTwoDigits(n) {
  return (n < 10 ? '0' : '') + n;
}

export default {
  props: {
    // videoUrl: {
    //   type: String,
    //   required: true
    // },
    presentationId: {
      type: String,
      required: true
    },
    // videoMap: {
    //   type: Array,
    //   required: true,
    //   validator: function (value) {
    //     return value.length > 0 && !value.find((item) => {return !item.hasOwnProperty('time')});
    //   }
    // },
  },
  data() {
    return {
      isPlaying: false,
      isVideoFetched: false,
      isMuted: false,
      plyTimeLine: null,
      swiper: null,
      currentObjectTime: null,
      stoppedManual: true,
      videoPercentage: 0,
      lastTimeChanged: null,
      transitionTime: .25,
      currentTime: 0,
      isMouseMoving: false,
      mouseMovingTimeout: null,
      videoMapData: null,
      videoUrl: null,
      isInitedVideo: false
    }
  },
  computed: {
    videoElement() {
      return this.$refs.video;
    },
    swiperContainerElement() {
      return this.$refs.swiperContainer;
    },
    lineStyle() {
      return (index) => {
        return {
          transform: `scaleX(${this.videoMapData[index].percentage})`,
          transition: `${this.videoMapData[index].isActive && this.isPlaying ? this.transitionTime : 0.1}s linear`
        }
      }
    },
    canSwipeSlide() {
      return (direction) => {
        if (this.swiper) {
          const currentIndex = this.swiper.realIndex;
          if (direction > 0) {
            return currentIndex + 1 < this.swiper.slides.length;
          } else {
            return currentIndex !== 0;
          }
        }
        return false;
      }
    },
    calculateSlideCounter() {
      return (number) => {
        return minTwoDigits(number);
      };
    }
  },
  created() {
    this.videoMapData = this.$t(`presentationSlides.${this.presentationId}.videoMap`);
    this.videoUrl = this.$t(`presentationSlides.${this.presentationId}.videoUrl`);
    this.videoMapData.sort(function (a, b) {
      return a.time < b.time ? -1 : 1
    });
    this.videoMapData.forEach((element, key) => {
      let nextKey = key + 1;
      let nextEl = null;
      if (nextKey in this.videoMapData) {
        nextEl = this.videoMapData[nextKey];
      }
      this.$set(element, 'nextEl', nextEl);
      this.$set(element, 'percentage', 0);
      this.$set(element, 'isActive', false);
      this.$set(element, 'id', key);
    });
  },
  mounted() {

    if (typeof gsap !== 'undefined') {
      this.plyTimeLine = gsap.timeline({defaults: {duration: 0.2}});
    }
    this.$nextTick(function () {
      this.isVideoFetched = true;
      const swiperContainer = this.swiperContainerElement;
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: false,
      });

      // this.restartPlayer();;


      let observer = new IntersectionObserver((event)=> {
        if (this.stoppedManual) {
          return;
        }
        if (event[0].isIntersecting && this.videoElement.paused) {
          this.playerPlay();
        }

        if (!event[0].isIntersecting && !this.videoElement.paused && this.videoElement.playing) {
          this.playerStop();
        }
      }, {
        root: null,
        threshold: 0.1
      });

      observer.observe(this.swiperContainerElement);
    })
  },
  methods: {
    onMouseMove: throttle(1000, function(e) {
      this.isMouseMoving = true;
      if (this.mouseMovingTimeout) {
        clearTimeout(this.mouseMovingTimeout);
      }
      this.mouseMovingTimeout = setTimeout(() => {
        this.isMouseMoving = false;
      }, 2000);
    }),
    onTimeUpdateListener() {
      this.currentTime = this.videoElement.currentTime;
      if (!this.currentObjectTime) {
        this.currentObjectTime = this.videoMapData.find(function (obj) {return obj.id === 0;});
      }

      const currentTime = this.currentTime;
      if (this.currentObjectTime.nextEl && currentTime >= this.currentObjectTime.nextEl.time) {
        this.currentObjectTime = this.currentObjectTime.nextEl;
        this.syncVideoSlider(true);
      }

      if(this.lastTimeChanged === null) {
        this.lastTimeChanged = new Date();
      }

      const now = new Date();
      const newTransition = (now - this.lastTimeChanged) / 1000;
      if (Math.abs(this.transitionTime - newTransition ) > 0.2) {
        this.transitionTime = newTransition;
      }
      this.lastTimeChanged = now;
      this.calculatePercentage();
    },
    calculatePercentage() {
      this.videoMapData.forEach((item, key) => {
        // this.$forceUpdate();
        let calculatedPercentage = 0;
        let nextBreakpoint = this.videoElement.duration;
        if(typeof this.videoMapData[key + 1] !== 'undefined') {
          nextBreakpoint = this.videoMapData[key + 1].time;
        }

        item.isActive = false;

        if (this.currentTime >= nextBreakpoint) {
          calculatedPercentage = 1;
        } else if (this.currentTime >= item.time) {
          let timeWindow = nextBreakpoint - item.time;
          calculatedPercentage = ((this.currentTime - item.time) / timeWindow);
          if (!item.isActive) {
            item.isActive = true;
          }
        }

        item.percentage = calculatedPercentage;
      });
      this.videoPercentage = (this.currentTime / this.videoElement.duration);
    },
    syncVideoSlider(isTimerInitiator = true) {

      if (isTimerInitiator) {
        const currentTime = this.currentTime;
        const neededSlideIndex = this.videoMapData.find(function (obj) {
          return obj.time <= currentTime && ((obj.nextEl !== null && obj.nextEl.time > currentTime) || obj.nextEl === null);
        }).id;

        this.swiper.slideTo(neededSlideIndex);
      } else {
        const currentSlide = this.swiper.realIndex;
        const slideFromMap = this.videoMapData.find(function (obj) {return obj.id === currentSlide});
        this.currentObjectTime = slideFromMap;

        this.videoElement.currentTime = slideFromMap.time;
      }
    },
    onTimeEnd() {
      this.currentTime = 0;
      this.currentObjectTime = null;
      this.playerStop(true);
    },
    playerPlayToggle() {
      if (this.isPlaying) {
        this.playerStop();
        this.stoppedManual = true;
      } else {
        this.playerPlay();
        this.stoppedManual = false;
      }
    },
    onLinkItemClick(index) {
      if (this.videoMapData[index] !== 'undefined') {
        const videoElement = this.videoMapData[index];
        if (!videoElement.isActive) {
          this.goToSlide(index);
        }
      }
    },
    goToSlide(slideNumber) {
      this.currentTime = this.videoMapData[slideNumber].time;
      this.swiper.slideTo(slideNumber);
      this.syncVideoSlider(false);
      this.calculatePercentage();
    },
    firePreviousSlide() {
      const currentIndex = this.swiper.realIndex;
      let nextIndex = currentIndex - 1;
      if (nextIndex < 0) {
        return;
        // nextIndex = this.swiper.slides.length - 1;
      }
      this.goToSlide(nextIndex);
    },
    fireNextSlide() {
      const currentIndex = this.swiper.realIndex;
      let nextIndex = currentIndex + 1;
      if (nextIndex >= this.swiper.slides.length) {
        return;
        // nextIndex = 0;
      }
      this.goToSlide(nextIndex);
    },
    playerPlay() {
      this.isInitedVideo = true;
      this.videoElement.play();
      this.isPlaying = true;
      if (this.plyTimeLine) {
        this.plyTimeLine.to(document.getElementById("play"), {morphSVG: "#stop"});
      }
      this.syncVideoSlider(true);
    },
    restartPlayer() {
      this.currentObjectTime = null;
      this.playerPlay();
      this.syncVideoSlider(true);
    },
    playerStop(isStoppedManual = false) {
      this.videoElement.pause();
      if (isStoppedManual) {
        this.stoppedManual = true;
      }
      this.isPlaying = false;
      if (this.plyTimeLine) {
        this.plyTimeLine.to(document.getElementById("play"), {morphSVG: "#play"});
      }
    },
  }
};
